<template>
  <div class="issueadd" v-dragDiv v-if="addShow">
    <div class="addTitle moveDragDiv">
      <span>模型图纸</span>
      <i class="el-icon-close" @click="closeArea"></i>
    </div>
    <el-select size="mini" class="selectmodel" v-model="modelId" placeholder="请选择模型" @change="selectTab" >
      <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id" ></el-option>
    </el-select>
    <div class="nav">
      <div v-for="(ele, index) in groupPics" :key="index" class="dwgInfo" @click="showDwg(ele)" >
        <img :src="ele.downloadUrl" alt="图纸缩略图" />
        <p :title="ele.drawName">{{ ele.drawName }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import docService from '@/CommonDP/service/doc-service';
import { getToken, baseUrl } from '@/CommonDP/utils';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      addShow: false,
      options: [],
      modelId: '',
      picsData: [], //所有的模型图纸
      newURLPicData: [], //处理后的图纸
      groupPics: [],
      hasNameDwg: '',
    };
  },
  computed: {
    ...mapState({
      modelUrlData: (state) => state.monge.modeldata,
      dwgModelId: (state) => state.monge.dwgModelId,
    }),
  },
  watch: {
    dwgModelId(val, oldval) {
      this.groupPics=[];
      this.changeTab();
    },
  },
  methods: {
    openArea() {
      this.addShow = true;
      this.hasNameDwg = '';
      this.$nextTick(async () => {
        await this.dealDwgListFunc();
      });
    },
    openNameDwg(name) {
      this.hasNameDwg = name;
      this.dealDwgListFunc();
    },
    async dealDwgListFunc() {
      this.picsData = [];
      this.options = Monge.Model.getModels();
      this.modelId = this.options[0].id;
      const modelList = this.options[0]?.url?.bimexDetailList||[];
      this.groupPics = modelList.filter(ele=>ele.label=="2D-IMG")
      if(this.hasNameDwg){
        let element = {};
        if(!!this.modelUrlData.fileObj){//整合模型
          this.options.forEach(ele=>{
            if(ele?.url?.bimexDetailList.some(item =>item.drawName == this.hasNameDwg)){
              this.modelId = ele.id;
              element = ele?.url?.bimexDetailList.find(item =>item.drawName == this.hasNameDwg && item.label=="2D-IMG")
            }
          })
        }else{
          element = this.options[0]?.url?.bimexDetailList.find(item =>item.drawName == this.hasNameDwg && item.label=="2D-IMG")
        }
        this.getModelPic(element);
      }
    },
    async getDwgList(fileId, rvtVersion) {
      const res = await docService.queryDwgList(fileId, rvtVersion);
      if (res.data && res.data.length > 0) {
        this.picsData = [...res.data];
        for (let item of this.picsData) {
          if (item.fileType === 2) {
            if (item.parentId === 'SheetViews') {
              let picsurl = baseUrl() + '/api/v1/doc/unzip-file/preview/' + item.id + '?token=' + getToken() + '&fileName=/';
              let picName = item.fileName;
              let imgurl = baseUrl() + '/api/v1/doc/unzip-file/preview/image/' + item.id + '?token=' + getToken();
              let imgid = item.id;
              let paperid = item.paperId;
              let list = this.$parent.$refs.modelView.modeldurlid;
              let modelurl = list.find((ele) => ele.rvtId == fileId).modelurl;
              this.newURLPicData.push({
                picName,
                picsurl,
                imgurl,
                imgid,
                modelurl,
                paperid,
              });
            } else if (item.fileType === 1) {
              // 不知道干啥的先不用
            }
          }
        }
        console.log(this.newURLPicData);
      }
    },
    dealgGroup() {
      this.options = Monge.Model.getModels();
      this.modelId = this.options[0].id;
      this.$store.dispatch('setDwgModelId', this.modelId);
      this.groupPics = this.newURLPicData.filter(
        (ele) => ele.modelurl == this.options[0].url
      );
    },
    selectTab() {
      this.$store.dispatch('setDwgModelId', this.modelId);
    },
    changeTab() {
      const modelList = this.options.find((ele) => ele.id == this.modelId).url?.bimexDetailList||[];
      this.groupPics = modelList.filter(ele=>ele.label=="2D-IMG")
    },
    showDwg(element){
      this.$store.dispatch("setAnnotationData", '')
      this.getModelPic(element);
    },
    getModelPic(element) {
      Monge.Map.unload('dwgbox');
      const { drawName } = element;
      const list = this.options.find(ele => ele.id == this.modelId)?.url?.bimexDetailList||[];
      const pageFile = list.filter(ele=>ele.drawName == drawName)
      this.$store.dispatch('setmodelPageFileName', drawName);
      this.$parent.$refs.modelView.openDwg(pageFile,drawName);
    },

    closeArea() {
      this.addShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.issueadd {
  position: absolute;
  top: 65px;
  left: 151px;
  width: 280px;
  height: calc(100% - 190px);
  max-height: 770px;
  z-index: 5;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0px 0px 4px 1px rgba(46, 91, 255, 0.17);
  border-radius: 4px;
  .addTitle {
    cursor: move;
    width: 100%;
    height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #e8ebef;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    span {
      font-size: 16px;
      font-weight: bold;
    }
    i {
      font-size: 16px;
      cursor: pointer;
    }
  }
  .selectmodel {
    width: 100%;
    // padding-top: 5px;
    padding: 5px 10px 0 10px;
    max-height: 50px;
  }
  .nav {
    width: 100%;
    height: calc(100% - 100px);
    padding: 0 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    cursor: pointer;
    .dwgInfo {
      width: 100%;
      height: 200px;
      border-bottom: 1px solid #b9bdc4;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 0 5px 0;
      img {
        width: 216px;
        height: 127px;
      }
      p {
        width: 216px;
        font-size: 14px;
        line-height: 30px;
        color: #2c3e50;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
